import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Row from 'component/utils/Row'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import InputNumber from 'component/form/InputNumber'
import CustomCompanySelect from 'component/branch/CustomCompanySelect'
import HierarchySelect from 'component/hierarchy/HierarchySelect'
import CustomMissionSelect from 'component/menuMission/CustomMissionSelect'
import { colourStyles } from 'utils/selectStyle'

const FIELDS = [
  'dsLdap',
  'nmUser',
  'idBranch',
  'dsBranch',
  'idSection',
  'dsSection',
  'cdMission',
  'dsEmail',
  'dsPassword',
]

class EditForm extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    resetFormTrigger: PropTypes.bool,
    scrollTop: PropTypes.number.isRequired,
    setValueToField: PropTypes.func.isRequired,
    sideFilterVisible: PropTypes.bool,
    token: PropTypes.string,
    translate: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
  }

  componentDidUpdate(prevProps) {
    const { resetFormTrigger, resetForm } = this.props

    if (resetFormTrigger !== prevProps.resetFormTrigger) {
      resetForm()
    }
  }

  beforeHandleSubmit = (event) => {
    const { handleSubmit, values } = this.props

    event.preventDefault()

    handleSubmit(values)
  }

  setBranchInfo = (option) => {
    const { setValueToField } = this.props

    setValueToField('idBranch', option.value)
    setValueToField(
      'dsBranch',
      !option.label || option.label.replace(/\d+ - /, '')
    )
  }

  setSectionInfo = (option) => {
    const { setValueToField } = this.props

    setValueToField('idSection', option.value)
    setValueToField('dsSection', option.label)
  }

  render() {
    const {
      fields,
      scrollTop,
      setValueToField,
      sideFilterVisible,
      token,
      translate,
      values,
    } = this.props

    return (
      <div
        ref={this.sideFilterRef}
        className='filter-adjustment side-filter margin-top-negative'
        style={{
          display: sideFilterVisible ? 'block' : 'none',
          height: `${scrollTop}vh`,
        }}
      >
        <form onSubmit={this.beforeHandleSubmit}>
          <Row className='margin-top-small'>
            <Field {...fields.dsLdap}>
              <InputNumber
                {...fields.dsLdap.input}
                integer
                label={translate('localUsers.editForm.field.dsLdap')}
                maxLength={8}
              />
            </Field>
          </Row>

          <Row className='margin-top-small'>
            <Field {...fields.nmUser}>
              <Input
                {...fields.nmUser.input}
                label={translate('localUsers.editForm.field.nmUser')}
                maxLength={100}
              />
            </Field>
          </Row>

          <Row className='margin-top-small'>
            <Field {...fields.idBranch}>
              <CustomCompanySelect
                {...fields.idBranch.input}
                onChange={this.setBranchInfo}
                token={token}
                translate={translate}
                excludeInactive={true}
              />
            </Field>
          </Row>

          <Row className='margin-top-small'>
            <Field {...fields.idSection}>
              <HierarchySelect
                {...fields.idSection.input}
                isClearable
                onChange={this.setSectionInfo}
                placeholder={translate('localUsers.editForm.field.idSection')}
                query={{ level: 2 }}
                styles={colourStyles}
                translate={translate}
              />
            </Field>
          </Row>

          <Row className='margin-top-small'>
            <Field {...fields.cdMission}>
              <CustomMissionSelect
                {...fields.cdMission.input}
                onChange={(value) =>
                  setValueToField(fields.cdMission.input.name, value)
                }
                token={token}
                translate={translate}
              />
            </Field>
          </Row>

          <Row className='margin-top-small'>
            <Field {...fields.dsEmail}>
              <Input
                {...fields.dsEmail.input}
                label={translate('localUsers.editForm.field.dsEmail')}
                maxLength={100}
                translate={translate}
              />
            </Field>
          </Row>

          <Row className='margin-top-small'>
            <Field {...fields.dsPassword}>
              <Input
                {...fields.dsPassword.input}
                label={translate('localUsers.editForm.field.dsPassword')}
                maxLength={100}
                translate={translate}
              />
            </Field>
          </Row>

          <Row className='margin-top-small'>
            <button
              className='button button-primary button-full margin-top'
              disabled={Object.values(values).some((value) => !value)}
            >
              {translate('register_button')}
            </button>
          </Row>
        </form>
      </div>
    )
  }
}

export default Form({ fields: FIELDS })(EditForm)

export { EditForm }
